import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useCampaignClearEffects from '../useCampaignClearEffects'
import usePermissions from '../../../../hooks/usePermissions'

import { insertIf } from '../../../../helpers/common'

import { openForm } from '../../../../modules/actions/forms'
import { updateCampaign } from '../../../../modules/actions/campaigns'
import { selectedFacebookAdAccountSelector } from '../../../../modules/selectors/adAccounts'

import { listItemChangeStatus } from '../../../../constants/other'
import { FACEBOOK_PLATFORM } from '../../../../constants/selectLists/platformList'
import {
  CAMPAIGN_FACEBOOK_DUPLICATE,
  CAMPAIGN_FACEBOOK_EDIT,
  CHANGE_CAMPAIGN_HISTORY
} from '../../../../constants/forms'
import { HISTORY_META_EDIT_SECTION } from '../../../../constants/changeHistory'

const useGetFacebookCampaignActions = handleDeleteRequest => {
  const dispatch = useDispatch()

  const permissions = usePermissions()

  const { id: facebookAdAccountId } = useSelector(selectedFacebookAdAccountSelector)

  useCampaignClearEffects()

  return useCallback(
    campaign => {
      const { id, status } = campaign
      return [
        ...insertIf(permissions.can('update', 'Campaign'), {
          text: 'Edit',
          onClickHandler: () => dispatch(openForm({ id, formName: CAMPAIGN_FACEBOOK_EDIT }))
        }),
        ...insertIf(permissions.can('create', 'Campaign'), {
          text: 'Duplicate',
          onClickHandler: () => dispatch(openForm({ id, formName: CAMPAIGN_FACEBOOK_DUPLICATE }))
        }),
        ...insertIf(permissions.can('update', 'Campaign'), {
          text: status === 'active' ? 'Pause' : 'Activate',
          onClickHandler: () => {
            dispatch(
              updateCampaign(
                {
                  status: listItemChangeStatus[status].changeTo,
                  account: facebookAdAccountId,
                  // meta field will add additional details for change history of the campaign
                  meta: {
                    [HISTORY_META_EDIT_SECTION]: 'Status'
                  }
                },
                id,
                FACEBOOK_PLATFORM
              )
            )
          }
        }),
        {
          text: 'Change History',
          onClickHandler: () => dispatch(openForm({ id, formName: CHANGE_CAMPAIGN_HISTORY }))
        },
        ...insertIf(permissions.can('delete', 'Campaign'), {
          text: 'Delete',
          onClickHandler: () =>
            handleDeleteRequest({
              item: campaign,
              platform: FACEBOOK_PLATFORM,
              account: facebookAdAccountId
            })
        })
      ]
    },
    [dispatch, facebookAdAccountId, permissions, handleDeleteRequest]
  )
}

export default useGetFacebookCampaignActions
